import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { SearchRequest } from '../common/SearchRequest';


export class CategorySearchRequest extends SearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public isEnabled?: boolean = null;
	public isFeatured?: boolean = null;

	constructor(init?: any) {
		super(init);
		if (!init) { return; }

		if (init.isEnabled != null) { this.isEnabled = (init.isEnabled.toString() === 'true'); }
		if (init.isFeatured != null) { this.isFeatured = (init.isFeatured.toString() === 'true'); }

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('category-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as CategorySearchRequest;
		if (!prevFilter) { return; }

	}

	/** Collapses the values in this search request object so they can be persisted to a query string */
	public collapse(): any {
		const response: { [k: string]: any } = super.collapse();
		if (this.isEnabled != null) { response.isEnabled = this.isEnabled; }
		if (this.isFeatured != null) { response.isFeatured = this.isEnabled; }
		return response;
	}

	/** Clears the values in this search request object */
	public clear() {
		super.clear();
		this.isEnabled = null;
		this.isFeatured = null;
	}

}
